// extracted by mini-css-extract-plugin
export default {"item":"item__1mN0y","specialOffersPlacementContainer":"specialOffersPlacementContainer__IxjIu","listRow":"listRow__uCLLR"};